class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M2.334 14 5.53 8l3.651 3.243a.999.999 0 0 0 1.56-.3l2.76-5.494L12.589 5l-2.746 5.5-3.649-3.246A.989.989 0 0 0 5.354 7a.994.994 0 0 0-.711.5L2 12.5V1H1v13a1 1 0 0 0 1 1h13v-1H2.334Z"></path></svg>';
  }
}
const t = "pi-mod-monthly-statistics";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
